<template>
	<b-modal id="fall-report-modal" ref="fallModalRef" title="Fall / Man Down Report" class="" :class="" centered size="lg">

		<div class="table-wrapper">
			<table class="table table-striped table-hover">
				<thead>
				<tr>
					<th>#</th>
					<th>Asset Name</th>
					<th>Zone Name</th>
					<th>Occurrence Time</th>
					<th>Resolution Time</th>
					<th>Duration</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(item, key, index) in events">
					<td>{{key + 1}}</td>
					<td>{{item.worker.first_name+' '+item.worker.last_name}}</td>
					<td>{{ $zone.get(item.zone_id).name }}</td>
					<td>{{$datetime.datetime(item.time, item.day)}}</td>
					<td>{{ Object.keys(item.result).length ? $datetime.datetime(item.result.time, item.result.day) : '' }}</td>
					<td>{{ Object.keys(item.result).length ? moment.utc(( (item.result.time * (item.result.day - item.day + 1) ) - item.time)*1000).format('HH:mm:ss') : moment.utc((time - item.time)*1000).format('HH:mm:ss') }}</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div slot="modal-footer">
			<b-btn type="button" class="btn btn-dark pl-4 pr-4" @click="$refs.fallModalRef.hide()">Close</b-btn>
		</div>

	</b-modal>
</template>
<script>
	export default {
		name: 'ZoneViolationReport',
		computed: {
			alert() { return this.$store.state.alert },
			time() { return this.$store.state.time },
			events() {
				let listing = Object.assign(this.$finder.all({type: 'fall'}, this.alert), this.$finder.all({type: 'man-down'}, this.alert));
				listing = this.$finder.order(listing, 'day,time');
				return listing;
			}
		},
		mounted() {
			//console.log(this.alert);
		}
	}
</script>
